import React from "react";

import { connect } from "react-redux";

import {
    setQualificationSideBarSelectionAction,
    toggleQualififcationSideBarAction,
} from "app/actions/qualificationSideBarActions";

import { selectIsQualificationSideBarOpen, selectQualificationSideBarSelection } from "./QualificationSideBarSelectors";
import type { QualificationSideBarSelectionType } from "./types";
import { SelectionType } from "./types";

const mapStateToProps = (state) => {
    return {
        isQualificationSideBarOpen: selectIsQualificationSideBarOpen(state),
        qualificationSideBarSelection: selectQualificationSideBarSelection(state),
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        toggleQualificationSideBar: (shouldOpen: boolean) => {
            dispatch(toggleQualififcationSideBarAction(shouldOpen));
        },
        setQualificationSideBarSelection: (selection: QualificationSideBarSelectionType) => {
            dispatch(setQualificationSideBarSelectionAction(selection));
        },
    };
};

export const QualificationSideBarHOC = (Component) => {
    return connect(
        mapStateToProps,
        mapDispatchToProps,
    )(
        class extends React.Component<any, any> {
            constructor(props) {
                super(props);
            }
            handleOpenQualificationSideBar = (row: { Domain: string; Favicon: string; ComponentId?: string }) => {
                const { Domain, Favicon, ComponentId } = row;
                if (this.props.qualificationSideBarSelection?.data?.domain === Domain) {
                    this.props.toggleQualificationSideBar(!this.props.isQualificationSideBarOpen);
                } else {
                    this.props.setQualificationSideBarSelection({
                        type: SelectionType.Website,
                        data: {
                            domain: Domain,
                            favicon: Favicon,
                            componentId: ComponentId,
                        },
                    });
                    !this.props.isQualificationSideBarOpen &&
                        this.props.toggleQualificationSideBar(!this.props.isQualificationSideBarOpen);
                }
            };
            render() {
                return (
                    <Component
                        {...this.props}
                        handleOpenQualificationSideBar={this.handleOpenQualificationSideBar}
                    />
                );
            }
        },
    );
};
